import { useEffect } from 'react';
import { Row, Col, Form, Button, Input } from './../ot';

const ClassifyStructureDepthForm = ({
    propsForm = null,
    formReloadCount = 0,
    onFormFinish = () => { },
    prefix = "",
    record = {},
    fieldName,
    propsFirstDepth = '系統角色'
}) => {
    const [form_] = Form.useForm();
    const form = propsForm || form_

    const setFormValuesOtherThings = (formValues) => {
        //做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
            // total: (formValues?.comments * formValues?.number) || 0
        }
        if (propsForm) {
            propsForm.setFieldsValue(newFormValues)
        }
        else {
            form.setFieldsValue(newFormValues)
        }

    }
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
    }
    const onFinish = (values) => {
        onFormFinish(values?.[prefix + '_depth_data'] || [])
        // let news_time = dayjs(values?.news_time).format("YYYY-MM-DD HH:mm:ss")
        // let announce_time_end = dayjs(values?.announce_time_end).format("YYYY-MM-DD HH:mm:ss")
        // onFormFinish({
        //     ...values,
        //     news_time,
        //     announce_time_end
        // })

    }
    const onValuesChange = () => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
        setFormValuesOtherThings(formValues)
    }

    useEffect(() => {
        setDataInitialization()
    }, [])
    useEffect(() => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
        (propsForm ?? form).setFieldsValue(formValues)
    }, [formReloadCount])

    const data = Form.useWatch(fieldName ? [fieldName ?? '', prefix + '_depth_data'].join('.') : prefix + '_depth_data', (propsForm ?? form))
    return (
        <Row>
            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                // initialValues={{
                //     [fieldName ? [fieldName ?? '', prefix + '_depth_data'].join('.') : prefix + '_depth_data']: [{
                //         depth_id: 0,
                //         name: '系統角色'
                //     }]
                // }}
                >
                    <Form.List
                        name={fieldName ? [fieldName ?? '', prefix + '_depth_data'].join('.') : prefix + '_depth_data'}>
                        {(fields, { add, remove }) => <>
                            <Row justify={'end'}>
                                <Col>
                                {console.log((propsForm || form_).getFieldsValue())}
                                    <Button onClick={() => add(
                                        fields.length === 0 ? [{
                                            [prefix + '_id']: record?.[prefix + '_id'],
                                            depth_id: (fields.length),
                                            name: propsFirstDepth
                                        }, {
                                            [prefix + '_id']: record?.[prefix + '_id'],
                                            depth_id: (fields.length + 1)
                                        }] : {
                                            [prefix + '_id']: record?.[prefix + '_id'],
                                            depth_id: (fields.length)
                                        })}>新增層級</Button>
                                </Col>
                            </Row>
                            {fields.map((field, index) => <>
                                <Row gutter={[8, 8]}>
                                    <Col span={24}>
                                        <Form.Item
                                            hidden={true}
                                            name={[field.name, prefix + "_depth_id"]}
                                        >
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item
                                            hidden={true}
                                            name={[field.name, "depth_id"]}
                                        >
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item
                                            hidden={true}
                                            name={[field.name, prefix + "_id"]}
                                        >
                                        </Form.Item>
                                    </Col>
                                    {index !== 0 &&
                                        <Col span={24}>
                                            <Row justify={'end'} gutter={[8, 8]}>
                                                <Col span={12}>
                                                    <Form.Item
                                                        label={`第${(index)}層級標題`}
                                                        name={[field.name, "name"]}
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: "請輸入"
                                                            }
                                                        ]}
                                                    >
                                                        <Input>
                                                        </Input>
                                                    </Form.Item>
                                                </Col>
                                                <Col>
                                                    <Button
                                                        type={'danger'}
                                                        onClick={() => remove(index)}
                                                        style={fields.length - 1 === index ? {} : {
                                                            display: 'none'
                                                        }}
                                                    >刪除</Button>
                                                </Col>
                                            </Row>
                                        </Col>
                                    }
                                </Row>
                            </>)}
                        </>}
                    </Form.List>
                </Form>
            </Col>
        </Row>
    )
}

export default ClassifyStructureDepthForm